import React, { PureComponent, Fragment } from 'react';
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import Thanks from "../components/Thanks";

class Success extends PureComponent {
    render(){
        return (
            <Fragment>
                <NavBar pageName="payment" />
                <Thanks />
                <Footer />
            </Fragment>
        )
    }
}
export default Success;